<template>
  <tr
    :data-test="'reservation-' + reservation.id"
  >
    <td
      class="boss-table-data"
    >
      <span
        data-test="reservation-name"
        class="pega-word-break-break-word"
      >{{ reservation.name }}
      </span>
      <template v-if="isReserved">
        <span
          v-if="reservation.includeFirstSendUser"
          data-test="reservation-first-send"
          class="boss-status-label pega-status-label position-static"
        >初送
        </span>
        <span
          v-else
          data-test="reservation-resent"
          class="boss-status-label pega-status-label position-static pega-status-label-black"
        >再送
        </span>
      </template>
    </td>
    <td
      data-test="reservation-subject"
      class="boss-table-data pega-word-break-break-word"
    >
      {{ reservation.subject }}
    </td>
    <td
      class="boss-table-data"
    >
      <span
        v-for="(favor, i) in reservation.specialFavors"
        :key="i"
        v-tooltip="{ content: specialFavorBy(favor.id).description}"
        :data-test="'special-favor-' + reservation.id + '-' + favor.id"
        class="boss-bonus-check-text boss-check-true"
      >{{ favor.name }}</span>
    </td>
    <td
      data-test="reservation-send-date"
      class="boss-table-data"
    >
      {{ reservation.sendDate | parseDateFormat }}
    </td>
    <td
      data-test="reservation-status"
      class="boss-table-data"
    >
      <span>
        {{ reservation.status.name }}
      </span>
    </td>
    <td
      class="boss-table-data"
    >
      <span
        v-if="!isReserved"
        data-test="reservation-count"
      >{{ `${reservation.count}通/` }}</span>
      <span data-test="reservation-expectation-count">{{ reservation.expectationCount }}</span>通
    </td>
    <template v-if="showEdit">
      <td class="boss-table-data">
        <button
          v-if="isEdit"
          class="boss-icon-pencil"
          data-test="reservation-edit"
          @click="$router.push({ name: 'scoutCreateReservation', params: {
            idAndNameObjects: reservation.targetUsers,
            jobId: jobId,
            contractId: contractId,
            reservationId: reservation.id
          }})"
        />
      </td>
      <td class="boss-table-data">
        <button
          v-if="isEdit"
          class="boss-icon-trash"
          data-test="reservation-remove"
          @click="doRemove(reservation.id)"
        />
      </td>
    </template>
  </tr>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { createDate } from '@/lib/dateUtils.js'

export default {
  filters: {
    parseDateFormat (val) {
      return createDate(val)?.format('YYYY/MM/DD HH:mm頃') ?? ''
    }
  },
  props: {
    reservation: {
      type: Object,
      required: true
    },
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    showEdit: {
      type: Boolean,
      default: true
    }

  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    isEdit () {
      return this.isReserved
    },
    isReserved () {
      return this.reservation.status.id === 0 // TODO 予約中
    }
  },
  methods: {
    ...mapMutations('contracts', [
      'fetchScoutAmount'
    ]),
    removeReservation (id) {
      return this.$http.secured.delete(`/scout/message/send/scouts/contracts/${this.contractId}/jobs/${this.jobId}/scouts/reservations/${id}`)
    },
    doRemove (id) {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeReservation(id) // 削除して
            .then(() => {
              this.$toasted.global.success({ message: 'スカウト予約を削除しました' })
              this.fetchScoutAmount({ contractId: this.contractId })
              this.$emit('fetch') // 一覧情報を取り直す
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
